/** Run work after first paint — avoids long main-thread tasks during Lighthouse / cold load. */
export function scheduleIdleTask(run: () => void, timeoutMs = 5000): void {
  if (typeof window === 'undefined') {
    run();
    return;
  }
  const ric = (
    window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    }
  ).requestIdleCallback;
  if (typeof ric === 'function') {
    ric(() => run(), { timeout: timeoutMs });
  } else {
    window.setTimeout(run, Math.min(timeoutMs, 2000));
  }
}

/** True for public homepage cold load — defer non-essential work. */
export function isHomeColdLoad(url?: string): boolean {
  let target = url;
  if ((!target || target === '/') && typeof window !== 'undefined') {
    target = window.location.pathname;
    if ((!target || target === '/') && window.location.hash) {
      target = window.location.hash.replace(/^#/, '');
    }
  }
  const path = (target || '/').split('?')[0].split('#')[0];
  return path === '/' || path === '';
}

